import { db } from "../../server";
import {interpolate} from "../helpers/stringHelper"
import {paths} from "../constants/dbPaths";

export function getTrackingOrder(userId, orderId) {
  return db.doc(interpolate(paths.TrackingOrderDoc,userId,orderId))
}
